export default {
  className: 'themeBackground',
  fields: [
    {
      name: 'image',
      tooltip: '建议750px * 400px',
      validators: [
        (val) => val ? null : '图片不可为空'
      ]
    },
    {
      name: 'position',
      validators: [
        (val) => val ? null : '位置不可为空'
      ]
    },
    {
      name: 'bgColor',
      tooltip: '主题背景颜色搭配主题图片设置，须和主题图片保持一致'
    },
    {
      name: 'decoration',
      tooltip: '建议690px * 390px'
    },
    'link'
  ],
  search: [
    'position'
  ],
  action: {
  }
}
